/**
 * Global functionality to add ellipsis drawing shapes to step-number elements
 */
class StepNumberManager {
  constructor() {
    this.init();
  }

  init() {
    // Initialize on DOM ready
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () =>
        this.setupStepNumbers()
      );
    } else {
      this.setupStepNumbers();
    }

    // Watch for dynamic content changes
    this.observeDOMChanges();
  }

  setupStepNumbers() {
    const stepNumbers = document.querySelectorAll(".step-number");
    stepNumbers.forEach((stepNumber) => {
      this.addEllipsisShape(stepNumber);
    });
  }

  addEllipsisShape(stepNumberElement) {
    // Check if SVG already exists to avoid duplicates
    if (stepNumberElement.querySelector(".step-circle-svg")) {
      return;
    }

    // Create the SVG element
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("class", "step-circle-svg");
    svg.setAttribute("viewBox", "0 0 100 160");
    svg.setAttribute("width", "100%");
    svg.setAttribute("height", "100%");
    svg.setAttribute("preserveAspectRatio", "xMidYMid meet");

    // Create the ellipse path
    const ellipse = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "ellipse"
    );
    ellipse.setAttribute("class", "step-circle-path");
    ellipse.setAttribute("cx", "50");
    ellipse.setAttribute("cy", "80");
    ellipse.setAttribute("rx", "45");
    ellipse.setAttribute("ry", "75");

    // Append ellipse to SVG
    svg.appendChild(ellipse);

    // Insert SVG as the first child of step-number element
    stepNumberElement.insertBefore(svg, stepNumberElement.firstChild);

    // Add animation class if element is visible
    this.triggerAnimation(stepNumberElement);
  }

  triggerAnimation(stepNumberElement) {
    // Use Intersection Observer to trigger animation when element becomes visible
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const path = entry.target.querySelector(".step-circle-path");
            if (path) {
              // Reset animation
              path.style.animation = "none";
              path.offsetHeight; // Trigger reflow
              path.style.animation = "drawEllipse 2s ease-out forwards";
            }
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "50px",
      }
    );

    observer.observe(stepNumberElement);
  }

  observeDOMChanges() {
    // Watch for new step-number elements being added dynamically
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if the added node is a step-number
            if (node.classList && node.classList.contains("step-number")) {
              this.addEllipsisShape(node);
            }

            // Check for step-number elements within the added node
            const stepNumbers = node.querySelectorAll
              ? node.querySelectorAll(".step-number")
              : [];
            stepNumbers.forEach((stepNumber) => {
              this.addEllipsisShape(stepNumber);
            });
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
}

// Initialize the step number manager
new StepNumberManager();
